import { MedicalImaging } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { MedicalImagingDetailsModal } from './MedicalImagingDetailsModal';

type MedicalImagingDetailsModalOpenerRenderer = (renderProps: { openModal: VoidFunction }) => JSX.Element;

type MedicalImagingDetailsModalOpenerProps = {
   readonly medicalImaging: MedicalImaging;
   readonly children: MedicalImagingDetailsModalOpenerRenderer;
   readonly onMedicalDataAccessAuthorizationUpdate?: VoidFunction;
};

export const MedicalImagingDetailsModalOpener = (props: MedicalImagingDetailsModalOpenerProps): JSX.Element => {
   const [{ setFalse: closeModal, setTrue: openModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}

         {modalOpened ? (
            <MedicalImagingDetailsModal
               medicalImaging={props.medicalImaging}
               onClose={closeModal}
               onMedicalDataAccessAuthorizationUpdate={props.onMedicalDataAccessAuthorizationUpdate}
            />
         ) : null}
      </>
   );
};
